export const ProductNameConstants = {
    GET_PRODUCT_NAME: 'GET_PRODUCT_NAME',
    SET_PRODUCT_NAME: 'SET_PRODUCT_NAME',
    RESET_PRODUCT_NAME: 'RESET_PRODUCT_NAME'
};